import $ from "jquery";

const processSlider = $(".process-slider");

function sliderInit() {
  if (!processSlider.hasClass("slick-initialized")) {
    processSlider.slick({
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow: $(".prev-arrow-process"),
      nextArrow: $(".next-arrow-process"),
      responsive: [
        {
          breakpoint: 1200,
          settings: "unslick",
        },
      ],
    });
  }
}

$(window).on("load resize orientationchange", function () {
  sliderInit();
});
if (!processSlider.hasClass("slick-initialized")) {
  sliderInit();
}
